import {GameStrategy} from '../base/GameStrategy';
import {TableController} from '../../../controllers/silent/TableController';
import {Stack} from '../../../pixi_scene/game_scene/game_table/table_objects/stacks/Stack';
import {CardData, MetaType} from '../../../data/active_data/field_config/card_stack_data/CardData';
import {SimiloButton} from '../../../pixi_scene/game_scene/game_table/table_objects/stacks/stack/SimiloButton';
import {CardStackDataEvent} from '../../../data/active_data/field_config/card_stack_data/CardStackDataEvent';
import {InteractionEvent} from 'pixi.js';
import {StaticData} from '../../../data/StaticData';

export class GuesserStarategy extends GameStrategy
{
    static similoButtons: Map<Stack, SimiloButton> = new Map<Stack, SimiloButton>();
    static stacks: Stack[] | undefined;
    private static gameState: any;

    /**
     * Добавить кнопку для Similo
     */
    static tryAddSimiloButton(e: InteractionEvent): void {
        let stack: Stack = e.currentTarget as Stack;
        if (stack.activeData.locked || GuesserStarategy.similoButtons.get(stack)) {
            return;
        }
        let cardData: CardData = stack.activeData.cards.getLast();
        console.log('cardData.metaType', '-=' + cardData.metaType + '=-');
        if (cardData.metaType == MetaType.PLAY) {
            let button: SimiloButton = new SimiloButton(cardData, stack);
            stack.addChild(button);
            GuesserStarategy.similoButtons.set(stack, button);
        }
    }

    static tryRemoveSimiloButton(e: InteractionEvent): void {
        let stack: Stack = e.currentTarget as Stack;
        GuesserStarategy.removeSimiloButton(stack);
    }

    static remove(): void {
        GuesserStarategy.stacks && GuesserStarategy.stacks.forEach(stack => {
            GuesserStarategy.removeSimiloButtonListeners(stack);
            GuesserStarategy.removeSimiloButton(stack);
        });
        GuesserStarategy.stacks = undefined;
        GuesserStarategy.similoButtons.clear();
    }

    private static removeSimiloButton(stack: Stack) {
        let button: SimiloButton | undefined = GuesserStarategy.similoButtons.get(stack);
        if (!button) {
            return;
        }
        GuesserStarategy.similoButtons.delete(stack);
        stack.removeChild(button!);
        button!.destroy();
    }

    private static addSimiloButtonListeners(stack: Stack): void {
        stack.on('pointerover', GuesserStarategy.tryAddSimiloButton);
        stack.on('pointerout', GuesserStarategy.tryRemoveSimiloButton);
        stack.activeData.addListener(CardStackDataEvent.FLIPPED, GuesserStarategy.onFlipped);
    }

    private static removeSimiloButtonListeners(stack: Stack): void {
        stack.off('pointerover', GuesserStarategy.tryAddSimiloButton);
        stack.off('pointerout', GuesserStarategy.tryRemoveSimiloButton);
        stack.activeData.removeListener(CardStackDataEvent.FLIPPED, GuesserStarategy.onFlipped);
    }

    private static onFlipped(): void {
        GuesserStarategy.remove();
    }

    isApplicable(gameState: any): boolean {
        //let applicable: boolean = gameState?.zones?.chat?.buttons?.similo?.delete?.enabled ?? false;
        let similoGame: boolean = gameState?.tasks?.state?.activity?.name == 'Similo';
        let role: number = gameState?.automation?.playersMap?.[StaticData.playerId]?.role?.value;
        let guessing: boolean = gameState?.automation?.informers?.stage?.image.indexOf('guess') > -1;
        let applicable: boolean = similoGame && role === 2 && guessing;
        console.warn('GUESSER Strategy aplicable:', applicable);
        return applicable;
    }

    disable(): void {
        if(!this.running){
            return;
        }
        GuesserStarategy.remove();
        super.disable();
    }

    execute(gameState: any): void {
        super.execute(gameState);
        console.warn('GUESSER Strategy execute');

        GuesserStarategy.gameState = gameState;
        GuesserStarategy.stacks = TableController.table.tableObjects!.stacks.stacks.concat();
        GuesserStarategy.stacks.forEach(stack => {
            GuesserStarategy.addSimiloButtonListeners(stack);
        });
    }
}
